<div class='header'>
  <img src="assets/imgs/music-together-logo.png">
</div>
<div class='body'>
  <div>
    <h3>We've detected you're using an unsupported browser.</h3>
    <span>Please use one of the following supported browsers to access this site.</span>
  </div>
  <div>
    <div>
      <a href='https://www.google.com/chrome/'>
        <img src='https://upload.wikimedia.org/wikipedia/commons/a/a5/Google_Chrome_icon_%28September_2014%29.svg'>
        <p>Chrome</p>
      </a>
      <a href='https://www.mozilla.org/en-US/firefox/new/'>
        <img src='https://upload.wikimedia.org/wikipedia/commons/6/67/Firefox_Logo%2C_2017.svg'>
        <p>Firefox</p>
      </a>
      <a href='https://www.apple.com/safari/'>
        <img src='https://upload.wikimedia.org/wikipedia/commons/5/52/Safari_browser_logo.svg'>
        <p>Safari</p>
      </a>
      <a href='https://www.microsoft.com/en-us/windows/microsoft-edge'>
        <img src='https://upload.wikimedia.org/wikipedia/commons/d/d6/Microsoft_Edge_logo.svg'>
        <p>Edge</p>
      </a>
    </div>
  </div>
</div>